import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import React from 'react'

interface IBadgeStatus {
  isInactive: boolean
}

const useStyles = makeStyles(() => ({
  badge: {
    padding: '0.25rem 0.5rem',
    color: '#FFFFFF',
    fontSize: '0.75rem',
    lineHeight: '1rem',
    fontWeight: 400,
    borderRadius: '1.25rem',
  },

  statusActive: {
    background: '#2E7D32',
  },

  statusInactive: {
    background: '#D8000C',
  },
}))

const BadgeStatus: React.FC<IBadgeStatus> = ({ isInactive }) => {
  const classes = useStyles()

  return (
    <span className={clsx(isInactive ? classes.statusInactive : classes.statusActive, classes.badge)}>
      {isInactive ? 'Inativo' : 'Ativo'}
    </span>
  )
}

export default BadgeStatus
